/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LanguageLevel } from './';
import {
    LanguageLevelFromJSON,
    LanguageLevelFromJSONTyped,
    LanguageLevelToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateLanguagesRequestSelectedLanguagesInner
 */
export interface UpdateLanguagesRequestSelectedLanguagesInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateLanguagesRequestSelectedLanguagesInner
     */
    code: string;
    /**
     * 
     * @type {LanguageLevel}
     * @memberof UpdateLanguagesRequestSelectedLanguagesInner
     */
    level: LanguageLevel;
}

/**
 * Check if a given object implements the UpdateLanguagesRequestSelectedLanguagesInner interface.
 */
export function instanceOfUpdateLanguagesRequestSelectedLanguagesInner(value: object): value is UpdateLanguagesRequestSelectedLanguagesInner {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    return true;
}

export function UpdateLanguagesRequestSelectedLanguagesInnerFromJSON(json: any): UpdateLanguagesRequestSelectedLanguagesInner {
    return UpdateLanguagesRequestSelectedLanguagesInnerFromJSONTyped(json, false);
}

export function UpdateLanguagesRequestSelectedLanguagesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLanguagesRequestSelectedLanguagesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'level': LanguageLevelFromJSON(json['level']),
    };
}

export function UpdateLanguagesRequestSelectedLanguagesInnerToJSON(value?: UpdateLanguagesRequestSelectedLanguagesInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'level': LanguageLevelToJSON(value['level']),
    };
}

